<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-sm-0 me-auto">Lokasi Klinik</h5>
              <form @submit.prevent="getDataList" class="d-flex gap-1">
                <div class="input-group">
                  <input
                    v-model="cariTitle"
                    type="text"
                    class="form-control bg-light"
                    placeholder="Pencarian..."
                    autocomplete="off"
                  >
                  <button class="btn btn-primary">Cari</button>
                </div>
              </form>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <div class="row g-4">
              <div class="col-sm-8 col-md-7 col-lg-4 col-xxl-3 order-2 order-lg-1">
                <form @submit.prevent="onSubmit" class="bg-light rounded p-4">
                  <label for class="col-form-label fs-4">Tambah Lokasi</label>

                  <hr class="border-0 pt-1 bg-dark rounded my-4">

                  <div class="form-floating mb-3">
                    <input
                      v-model="form.location_name"
                      type="text"
                      class="form-control bg-white"
                      placeholder="Nama Klinik..."
                      autocomplete="off"
                      required
                    >
                    <label for>Nama Klinik *</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input
                      v-model="form.address"
                      type="text"
                      class="form-control bg-white"
                      placeholder="Alamat..."
                      required
                    >
                    <label for>Alamat *</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input
                      v-model="form.city"
                      type="text"
                      class="form-control bg-white"
                      placeholder="Kota..."
                      required
                    >
                    <label for>Kota *</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input
                      v-model="form.province"
                      type="text"
                      class="form-control bg-white"
                      placeholder="Provinsi..."
                      required
                    >
                    <label for>Provinsi *</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input
                      v-model="form.postal_code"
                      type="number"
                      class="form-control bg-white"
                      placeholder="Kode Pos..."
                      required
                    >
                    <label for>Kode Pos *</label>
                  </div>

                  <hr>

                  <div class="form-floating mb-3">
                    <input
                      v-model="form.email"
                      type="email"
                      class="form-control bg-white"
                      placeholder="Alamat Email..."
                    >
                    <label for>Alamat Email</label>
                  </div>
                  <div class="form-floating mb-3">
                    <input
                      v-model="form.phone_number"
                      type="text"
                      class="form-control bg-white"
                      placeholder="No. Telpon..."
                    >
                    <label for>No. Telpon</label>
                  </div>

                  <hr>

                  <div class="form-floating mb-3">
                    <input
                      v-model="form.map_url"
                      type="url"
                      class="form-control bg-white"
                      placeholder="https://"
                    >
                    <label for>Embed Map URL</label>
                  </div>

                  <button type="submit" class="btn btn-primary mt-4 liveToastBtn">Simpan</button>
                </form>
              </div>

              <div class="col-lg-8 col-xxl-9 order-1 order-lg-2">
                <div class="table-responsive">
                  <table class="table align-middle table-striped table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th class="w-50 text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Nama Klinik
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th scope="col">Alamat</th>
                        <th class="text-nowrap" scope="col">Alamat Email</th>
                        <th class="text-center text-nowrap" scope="col">No. Telp</th>
                        <th class="text-end" scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(req, idx) in dataList" :key="req.id">
                        <th scope="row">{{ idx + 1 }}</th>
                        <td class="text-nowrap">
                          {{ req.location_name }} - {{ req.city }}
                          <div class="small text-dark">Lokasi : {{ req.map_url || '-' }}</div>
                        </td>
                        <td class="text-nowrap">
                          <div>{{ req.address }}</div>
                          <div class="small text-dark">{{ req.province }}</div>
                        </td>
                        <td class="text-nowrap">
                          <a
                            :href="`mailto:${req.email}`"
                            class="link-primary"
                            target="_blank"
                            :title="`Send mail to ${req.email}`"
                          >{{ req.email }}</a>
                        </td>
                        <td class="text-center text-nowrap">{{ req.email }}</td>
                        <td class="text-nowrap text-end">
                          <a
                            href="#"
                            class="btn btn-sm btn-outline-danger"
                            title="Hapus"
                            @click="deleteData(req.id)"
                          >
                            <i class="ti ti-trash fs-3"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <b-pagination
                  class="justify-content-center"
                  v-model="page"
                  :total-rows="countDataList"
                  :per-page="pageSize"
                  prev-text="Previous"
                  next-text="Next"
                  @change="handlePageChange"
                  size="md"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'

export default {
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			token: localStorage.getItem('token'),
			order: 'desc',
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50],
			form: {
				// id: '',
				location_name: '',
				address: '',
				city: '',
				province: '',
				postal_code: '',
				country: '',
				email: '',
				phone_number: '',
				map_url: '',
				statusId: '7'
			},
			cariTitle: '',
			formTitle: 'Add New',
			url: 'location',
			method: 'post'
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.getDataList()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
	},
	computed: {
		...mapGetters({
			dataList: 'location/getDCLocation',
			countDataList: 'location/getCountDCLocation'
		})
	},
	methods: {
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getData', {
					url: `location`,
					params: {
						location_name: this.cariTitle,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		},
		onSubmit() {
			this.$store
				.dispatch('location/createNewRecord', {
					data: this.form,
					url: this.url,
					method: this.method
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
						var myModalEl = document.getElementById('exampleModal')
						var modal = bootstrap.Modal.getInstance(myModalEl)
						modal.hide()
						this.form = {
							id: '',
							location_name: '',
							address: '',
							city: '',
							province: '',
							postal_code: '',
							country: '',
							email: '',
							phone_number: '',
							map_url: '',
							statusId: '7'
						}
					} else {
					}
				})
		},
		deleteData(id) {
			var conf = confirm('Kamu akan menghapus rekaman ini. Apa kamu yakin?')
			if (conf === false) {
				return
			}

			this.$store
				.dispatch('location/createNewRecord', {
					url: 'location/' + id,
					method: 'DELETE'
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					if (res.statusCode == 200) {
						this.getDataList()
					} else {
					}
				})
		},
		edit(id) {
			let data = this.dataList.find((o) => o.id === id)
			console.log(data)
			this.form = {
				id: id,
				location_name: data.location_name,
				address: data.address,
				city: data.city,
				province: data.province,
				postal_code: data.postal_code,
				country: data.country,
				email: data.email,
				phone_number: data.phone_number,
				map_url: data.map_url,
				statusId: data.statusId
			}
			this.formTitle = 'Edit'
			this.url = 'location/' + id
			this.method = 'put'
		},
		add() {
			this.form = {
				id: '',
				location_name: '',
				address: '',
				city: '',
				province: '',
				postal_code: '',
				country: '',
				email: '',
				phone_number: '',
				map_url: '',
				statusId: '7'
			}
			this.formTitle = 'Add New'
			this.url = 'location'
			this.method = 'post'
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
